import React from 'react'
import { SelectField, SelectFieldProps } from 'scenes/Dashboard/components-next/Forms/Controllers'

import { ScoutingCampaignStatus } from '../../../../../../../../../entities-next/scoutingCampaign'

export type ScoutingCampaignStatusSelectProps = Omit<SelectFieldProps, 'options' | 'getOptionLabel'>

const scoutingCampaignStatusValues = Object.values(ScoutingCampaignStatus)

const ScoutingCampaignStatusLabel: {
  [key in ScoutingCampaignStatus]: string
} = {
  [ScoutingCampaignStatus.inactive]: 'Inactive',
  [ScoutingCampaignStatus.draft]: 'Draft',
  [ScoutingCampaignStatus.pendingValidation]: 'Space - Pending Validation',
  [ScoutingCampaignStatus.calibrationPhase]: 'Space - Discovery',
  [ScoutingCampaignStatus.deliveryPhase]: 'Space - Delivery',
  [ScoutingCampaignStatus.lsRunning]: 'Light Search - Running',
  [ScoutingCampaignStatus.lsCompleted]: 'Light Search - Completed',
  [ScoutingCampaignStatus.ddPendingValidation]: 'Deep Dive - Pending Validation',
  [ScoutingCampaignStatus.ddRunning]: 'Deep Dive - Running',
  [ScoutingCampaignStatus.ddCompleted]: 'Deep Dive - Completed',
}

export function ScoutingCampaignStatusSelect(selectProps: ScoutingCampaignStatusSelectProps) {
  return (
    <SelectField
      options={scoutingCampaignStatusValues}
      getOptionLabel={(status: ScoutingCampaignStatus) => ScoutingCampaignStatusLabel[status]}
      isClearable={false}
      {...selectProps}
    />
  )
}
